export class CouldNotRemoveLastAdminUserFromCourtSystem extends Error {
  constructor(message: string) {
    super(message)
    Object.setPrototypeOf(this, CouldNotRemoveLastAdminUserFromCourtSystem.prototype)
  }
}
